import React from 'react';
import PropTypes from 'prop-types';

import { AlertBlock } from '@klarna/bubble-ui';

const Alert = ({
  content,
  icon = undefined,
  linkLabel = undefined,
  linkText = undefined,
  listItems = [],
  type = '',
  onLinkClick = () => {},
}) => {
  return (
    <AlertBlock
      iconType={icon}
      content={Array.isArray(content) ? content : [content]}
      listItems={listItems}
      link={linkText}
      linkLabel={linkLabel}
      onLinkClick={onLinkClick}
      status={type}
    />
  );
};

Alert.propTypes = {
  content: PropTypes.node.isRequired,
  icon: PropTypes.func,
  linkLabel: PropTypes.string,
  linkText: PropTypes.string,
  listItems: PropTypes.arrayOf(PropTypes.string),
  type: PropTypes.oneOf(['default', 'error', 'success', 'warning']),
  onLinkClick: PropTypes.func,
};

export default Alert;
